import {
  AirwallexPayment,
  AirwallexPaymentData,
  AirwallexPaymentRepository,
  DatabaseService,
} from "../core";
import { DatabaseCollection } from "./config";
import { getGenericRepository } from "./generic-repository";

export function getAirwallexPaymentRepository(
  databaseService: DatabaseService,
): AirwallexPaymentRepository {
  return getGenericRepository<AirwallexPayment, AirwallexPaymentData>(
    () => DatabaseCollection.AIRWALLEX_PAYMENTS,
    databaseService,
  );
}
